var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};




// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function() {
    var $trigger = $('.form__select');

    if (!$trigger.length) {
        return;
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
}



// Category Filter Redirect
//----------------------------------------------------------
mp.categoryFilter = function() {
    var $element = $('.js_categoryFilter');

    if (!$element.length) {
        return;
    }

    // Watcher for click events in dropdown
    $element.on('change', function() {
        $post_link = $(this).val();
        window.location.href = $post_link;
    });
};


// Header Search
//----------------------------------------------------------
mp.searchForm = function() {
    var $form = $('.js_searchForm');

    if (!$form.length) {
        return;
    }

    var $button = $form.find('.search__button');
    var $input = $form.find('.search__input');

    $button.on('click', function(e) {
        if ($input.val().length===0) {
            $input.focus();
            $form.toggleClass("focused");

            e.preventDefault();
            return;
        }
    });
};



// Newsletter Popup
//-----------------------------------------------------------------
mp.newsletterPopup = function() {
    $.fancybox.open({
        src  : '#newsletter-popup',
        type : 'inline',
        opts : {
            infobar: false,
        }
    });
};



$(document).ready(function (){
    mp.fancyBox();
    mp.selectric();
    mp.categoryFilter();
    mp.searchForm();
    //mp.backgroundHolder();
});